import { render, staticRenderFns } from "./changeInChain.vue?vue&type=template&id=5c5ce53c"
import script from "./changeInChain.vue?vue&type=script&lang=js"
export * from "./changeInChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports